// TODO: These valeus are repeated within SCSS:
// `_profile.scss` and `_social-links.scss`
// We need to have a better source of truth for these values.
// This should be resolved once we convert to CSS-in-JS.

export const cssCustomProperty = {
    top: '--yat_inline-input-top',
    left: '--yat_inline-input-left',
    right: '--yat_inline-input-right',
};

// SCSS var: $yat_social-links-per-row
export const itemsPerRow = 6;

// SCSS var: $yat_icon-link-list-item-size
export const itemSize = 36;

// SCSS var: $yat_icon-link-list-gap
export const itemGap = 8;

// TODO: This can likely be derived from some of the math within `_profile.scss`
export const listWidth = itemSize * itemsPerRow + itemGap * (itemsPerRow - 1);
